import {LabelWithoutJson} from '@/components/atoms'
import './_sectionTitle.scss'
import {FONT_SIZE, FONT_WEIGHT} from '@/shared/constants/globalStyle'
import PropTypes from 'prop-types'
/**
 * SectionTitle component renders a header section with a label.
 *
 * @param {Object} props - The component props.
 * @param {string} props.label - The text to display in the header.
 * @param {string} props.fontSize - The font size to use for the label.
 * @returns {JSX.Element} The rendered SectionTitle component.
 */
const SectionTitle = ({id, label, isBorderVisible = false, fontSize = FONT_SIZE.MD}) => {
  return (
    <div className={`${isBorderVisible && 'sc-border'} w-full pb-3 pt-5`}>
      <LabelWithoutJson
        id={`${id}_section_header`}
        text={label}
        fontWeight={FONT_WEIGHT.BOLD}
        fontSize={fontSize}
        color={'var(--color-text-primary)'}
      />
    </div>
  )
}

SectionTitle.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  isBorderVisible: PropTypes.bool,
  fontSize: PropTypes.string,
}

export default SectionTitle
